import AttachmentComponent from './attachment.component'

const AttachmentModule = angular.module('cdbl.attachments.attachment', [

])
  .component('cdblAttachment', AttachmentComponent)
  .name

export default AttachmentModule
